import React from 'react';

import { ThreeDStockHeaderProps } from './ThreeDStockHeader.types';

import { IndexTablePageHeader } from '../../../../common/components/headers/IndexTablePageHeader';

import { ThreeDStockHeaderAddButton } from './components/ThreeDStockHeaderAddButton';
import { ThreeDStockProductsSearchField } from '../../helpers/ThreeDStockProductsSearchField';
import { ThreeDStockLifestylesSearchField } from '../../helpers/ThreeDStockLifestylesSearchField';
import { ThreeDStockMaterialsSearchField } from '../../helpers/ThreeDStockMaterialsSearchField';
import { ThreeDStockHeaderTitleButton } from './components/ThreeDStockHeaderTitleButton';

import { StockTabs } from '../../../stockConstants';

function ThreeDStockHeader({
  tab,
  withSuggestInput,
  withSimilarImageFilter,
  value,
  onSearch,
  onSearchSimilarImage,
  onSearchInImage,
  disabled,
  withAddButton,
  withSearchField = true,
  withSimilarInImageFilter,
  isMyLibrary,
  isLib,
  libHref,
  stockHref,
  team
}: ThreeDStockHeaderProps) {
  return (
    <IndexTablePageHeader divClassName="flex-1 flex justify-between gap-4">
      <ThreeDStockHeaderTitleButton
        isLib={isLib}
        libHref={libHref}
        stockHref={stockHref}
      />

      {withSearchField && tab === StockTabs.PRODUCTS && (
        <ThreeDStockProductsSearchField
          withSuggestInput={withSuggestInput}
          withSimilarImageFilter={withSimilarImageFilter}
          withSimilarInImageFilter={withSimilarInImageFilter}
          value={value}
          onSearch={onSearch}
          onSearchSimilarImage={onSearchSimilarImage}
          onSearchInImage={onSearchInImage}
          disabled={disabled}
        />
      )}

      {withSearchField && tab === StockTabs.LIFESTYLES && (
        <ThreeDStockLifestylesSearchField
          withSimilarImageFilter={withSimilarImageFilter}
          value={value}
          onSearch={onSearch}
          onSearchSimilarImage={onSearchSimilarImage}
          disabled={disabled}
        />
      )}

      {withSearchField && tab === StockTabs.MATERIALS && (
        <ThreeDStockMaterialsSearchField
          value={value}
          onSearch={onSearch}
          disabled={disabled}
        />
      )}

      {withAddButton && (
        <ThreeDStockHeaderAddButton
          tab={tab}
          isMyLibrary={isMyLibrary}
          isLib={isLib}
          team={team}
        />
      )}
    </IndexTablePageHeader>
  );
}

export default ThreeDStockHeader;
